import React, {useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './Login.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import loginImage from '../../../images/emergencias-login.png';
import logo from '../../../images/logo-contigo-color.png';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import {Redirect, useHistory} from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {toast} from 'react-toastify';
import {Input} from '@mui/material';
import {IconButton, InputAdornment} from '@material-ui/core';
import CustomInput from '../../../common/components/CustomInput/CustomInput';
import Button from '../../../common/components/Button/Button';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const _Login = ({login, isLoggedIn, switchOfUser}) => {
    // eslint-disable-next-line react/prop-types
    const [showPassword, setShowPassword] = useState(false);

    const history = useHistory();

    const {executeRecaptcha} = useGoogleReCaptcha();

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async (values) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('yourAction');
        // Do whatever you want with the token
        if (token) {
            login({...values, captchaResponse: token});
            switchOfUser('Inicio');
        } else {
            toast.error('Error con reCaptcha');
        }
        // eslint-disable-next-line
    }, [executeRecaptcha]);


  const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },

        onSubmit: (values) => {
            handleReCaptchaVerify(values);
        },
    });

    return isLoggedIn ?
        <Redirect to='/home'/> :
        (
            < div className={"lg-v2-div-section"}>
            <div className="lg-v2-div-background">
                <div className="lg-v2-div-cont element-to-hide left-cont">
                    <img src={loginImage} alt={'login'} style={{borderRadius: 260}} className="lg-v2-img"/>
                </div>
                <div className="lg-v2-div-cont right-cont">
                    <div className="lg-v2-div-section">
                        <img src={logo} alt={'logo'} className="lg-v2-logo"/>
                        <form onSubmit={formik.handleSubmit} className="lg-v2-form">
                            <div className={'lg-v2-login-inputs'}>
                                <CustomInput
                                    label="Mail"
                                    placeholder="Mail"
                                    onChange={(value) => formik.handleChange({target: {name: 'email', value}})}
                                    value={formik.values.email}
                                />
                                <CustomInput
                                    label="Contraseña"
                                    placeholder="Contraseña"
                                    onChange={(value) => formik.handleChange({target: {name: 'password', value}})}
                                    value={formik.values.password}
                                    type={showPassword ? 'text' : 'password'}
                                    // TODO: change icon to the one on figma. Ask emi for the open eye icon.
                                    rightSlot={<InputAdornment style={{marginRight: '-15px'}}>
                                        <IconButton>
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>}
                                    rightSlotOnClick={() => setShowPassword(!showPassword)}
                                />
                            </div>
                            <div className="lg-v2-btns">
                                <Button size="large" type="submit"> Iniciar Sesión </Button>
                                <a href='/recovery-password' className="lg-v2-a"
                                   onClick={() => {
                                       history.push('/recovery-password');
                                   }}
                                >Olvidé mi contraseña</a>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
            </div>
        );
};

const mapStateToProps = (state) => ({
    isLoggedIn: state.login.isLoggedIn,
    loginState: state.login.loginState,
});

const mapDispatchToProps = (dispatch) => ({
    login: (body) => dispatch(actions.login.loginRequest(body)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
});

_Login.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(_Login);

